import moment from "moment";
import { useReducer } from "react";
import { useTranslation } from "react-i18next";
import TrademarkContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import { errorNotification } from "../../utils/helpers/notification";
import EndPoints from "../../services/end-points";
import {
  ICreateTrademark,
  IExportPurchaseInvoiceReport,
  IUpdateTrademark,
} from "../../models/trademark/request";
import { ITrademark } from "../../models/trademark/response";
import { ITrademarkQuery } from "../../models/trademark/query";
export interface IProps {
  children: React.ReactNode;
}
const TrademarkContextProvider: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.trademark.getAllTrademark(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.trademark.getTrademark(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: ITrademark) => {
    // dispatch({ type: 'SET_DETAILSS', payload: { details: data } })
  };

  const createTrademark = async (request: ICreateTrademark) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.trademark.createTrademark(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const updateTrademark = async (id: number, request: IUpdateTrademark) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.trademark.updateTrademark(id, request);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const deleteTrademark = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.trademark.deleteTrademark(id);

        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: ITrademarkQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.trademark.exportExcel(
          request,
          state.query
        );
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Trademarks-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const exportPurchaseInvoiceReport = async (request: IExportPurchaseInvoiceReport) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.trademark.exportPurchaseInvoiceReport(
          request,
          state.query
        );
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `trademarks_purchase_invoice_reports_${moment().format("YYYY-MM-DD HH:mm:ss")}.zip`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => {
        let errorMessage = t("server_error_try_again");

        try {
          // Handle ArrayBuffer response (when responseType is 'arraybuffer')
          if (error?.response?.data instanceof ArrayBuffer) {
            const decoder = new TextDecoder('utf-8');
            const text = decoder.decode(error.response.data);
            const errorData = JSON.parse(text);
            errorMessage = errorData.errors?.[0] || errorMessage;
          } else if (error?.response?.data?.errors?.[0]) {
            // Handle regular JSON response
            errorMessage = error.response.data.errors[0];
          } else if (error?.response?.errors?.[0]) {
            errorMessage = error.response.errors[0];
          } else if (error?.message) {
            errorMessage = error.message;
          }
        } catch (parseError) {
          console.error("Error parsing response:", parseError);
        }

        errorNotification(
          t("500"),
          errorMessage
        );
      },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };
  const updateCompaniesArrangementSectionList = async (
    request: {
        "sectionId":number,
        "trademarkId":number,
        "orderInCategory":number
      }
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.trademark.updateCompaniesArrangementSectionList(request);

        // getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };
  const updateCompaniesArrangementList = async (
    request: {
        "categoryId":number,
        "trademarkId":number,
        "orderInCategory":number
      }
  ) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.trademark.updateCompaniesArrangementList(request);

        // getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  return (
    <TrademarkContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,
          updateCompaniesArrangementList,
          updateCompaniesArrangementSectionList,
          createTrademark,
          updateTrademark,
          deleteTrademark,
          exportExcel,
          exportPurchaseInvoiceReport,

          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </TrademarkContext.Provider>
  );
};

export default TrademarkContextProvider;
